import { render } from "./DashboardRulesDetail.vue?vue&type=template&id=79c3b6d4&scoped=true"
import script from "./DashboardRulesDetail.vue?vue&type=script&lang=js"
export * from "./DashboardRulesDetail.vue?vue&type=script&lang=js"

import "./DashboardRulesDetail.vue?vue&type=style&index=0&id=79c3b6d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c3b6d4"]])

export default __exports__